var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhilosophy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Emoji-Thinking-Face--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Emoji Thinking Face Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25153 14.5596c0.23447 -1.2254 1.24391 -2.1893 2.52545 -2.3304 1.65297 -0.182 3.11578 1.0628 3.20601 2.7178l4.95791 -1.9205c1.5995 -0.6196 3.3912 0.2306 3.9228 1.8614 0.4923 1.5099 -0.2818 3.1412 -1.7627 3.7148l-1.9921 0.7717c0.0809 0.5259 0.1186 1.0981 0.0383 1.6574l-0.0047 0.0318c5.2702 -0.5694 9.3731 -5.0327 9.3731 -10.4542C22.5156 4.80176 17.8076 0.09375 12 0.09375c-5.80762 0 -10.51562 4.70801 -10.51562 10.51565 0 1.3971 0.27246 2.7306 0.76715 3.9502Zm8.07167 -6.40507c0.892 0.14866 1.7881 0.59046 2.4071 1.20947 0.2929 0.29289 0.2929 0.7678 0 1.0607 -0.2929 0.2929 -0.7678 0.2929 -1.0607 0 -0.381 -0.381 -0.9849 -0.68923 -1.5929 -0.79058 -0.61522 -0.10252 -1.08071 0.02483 -1.34642 0.29054 -0.29289 0.29294 -0.76777 0.29294 -1.06066 0 -0.29289 -0.29289 -0.29289 -0.76777 0 -1.06066 0.73429 -0.7343 1.7688 -0.85694 2.65358 -0.70947Zm-3.04818 -3.7602c0.62132 0 1.125 0.50368 1.125 1.125s-0.50368 1.125 -1.125 1.125 -1.125 -0.50368 -1.125 -1.125 0.50368 -1.125 1.125 -1.125Zm5.32498 0c0.6213 0 1.125 0.50368 1.125 1.125s-0.5037 1.125 -1.125 1.125 -1.125 -0.50368 -1.125 -1.125 0.5037 -1.125 1.125 -1.125Z",
    clipRule: "evenodd",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.1499 22.6c2 -0.8 1.625 -2.5625 1.225 -4.1625l3.1843 -1.2335c0.738 -0.2859 1.1237 -1.0988 0.8784 -1.8512 -0.2649 -0.8127 -1.1578 -1.2364 -1.9549 -0.9276l-5.85773 2.2691c-0.5 0.2 -1.1 -0.2 -1.1 -0.7l-0.03881 -0.9459c-0.03309 -0.8067 -0.74253 -1.4166 -1.54503 -1.3282 -0.70642 0.0778 -1.24118 0.6746 -1.24118 1.3853v4.0888c0 2.6 2.4 4.5 4.9 3.9 0 0 1.05 -0.2943 1.54995 -0.4943Z",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhilosophy);
export default ForwardRef;